/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { SeriesSummaryModel } from './SeriesSummaryModel';
import {
    SeriesSummaryModelFromJSON,
    SeriesSummaryModelFromJSONTyped,
    SeriesSummaryModelToJSON,
} from './SeriesSummaryModel';

/**
 * コミチプラスで扱われる特集ページ情報です。
 * 特集ページは連載作品と連載終了作品という2つ箇所が分けられています。
 * ＊タイルの箇所：連載作品
 * ＊連載終了作品の箇所：連載終了作品
 * @export
 * @interface SeriesMatomeModel
 */
export interface SeriesMatomeModel {
    /**
     * 作品まとめのID
     * @type {number}
     * @memberof SeriesMatomeModel
     */
    id?: number;
    /**
     * 
     * @type {ImageModel}
     * @memberof SeriesMatomeModel
     */
    image?: ImageModel;
    /**
     * 
     * @type {ImageModel}
     * @memberof SeriesMatomeModel
     */
    spImage?: ImageModel;
    /**
     * 作品まとめのタイトル
     * @type {string}
     * @memberof SeriesMatomeModel
     */
    title?: string;
    /**
     * 作品まとめの説明文
     * @type {string}
     * @memberof SeriesMatomeModel
     */
    description?: string;
    /**
     * 該当する作品まとめは公開されるかどうかのフラグ
     * @type {boolean}
     * @memberof SeriesMatomeModel
     */
    enabled?: boolean;
    /**
     * 連載終了作品
     * @type {Array<SeriesSummaryModel>}
     * @memberof SeriesMatomeModel
     */
    endedSeries?: Array<SeriesSummaryModel>;
    /**
     * 連載作品
     * @type {Array<SeriesSummaryModel>}
     * @memberof SeriesMatomeModel
     */
    series?: Array<SeriesSummaryModel>;
}

/**
 * Check if a given object implements the SeriesMatomeModel interface.
 */
export function instanceOfSeriesMatomeModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SeriesMatomeModelFromJSON(json: any): SeriesMatomeModel {
    return SeriesMatomeModelFromJSONTyped(json, false);
}

export function SeriesMatomeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesMatomeModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'image': !exists(json, 'image') ? undefined : ImageModelFromJSON(json['image']),
        'spImage': !exists(json, 'spImage') ? undefined : ImageModelFromJSON(json['spImage']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'endedSeries': !exists(json, 'endedSeries') ? undefined : ((json['endedSeries'] as Array<any>).map(SeriesSummaryModelFromJSON)),
        'series': !exists(json, 'series') ? undefined : ((json['series'] as Array<any>).map(SeriesSummaryModelFromJSON)),
    };
}

export function SeriesMatomeModelToJSON(value?: SeriesMatomeModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'image': ImageModelToJSON(value.image),
        'spImage': ImageModelToJSON(value.spImage),
        'title': value.title,
        'description': value.description,
        'enabled': value.enabled,
        'endedSeries': value.endedSeries === undefined ? undefined : ((value.endedSeries as Array<any>).map(SeriesSummaryModelToJSON)),
        'series': value.series === undefined ? undefined : ((value.series as Array<any>).map(SeriesSummaryModelToJSON)),
    };
}

